export var MockSelection = {
    shopType: [
        { id: 1, name: '标准店' },
        { id: 2, name: '旗舰店' },
        { id: 3, name: '迷你电' },
        { id: 4, name: '网红店' },
        { id: 5, name: '小店' },
    ],
    shopCategory: [
        { id: 1, name: '商铺' },
        { id: 2, name: '街铺' },
    ],
    status: [
        { id: 1, name: '未发布' },
        { id: 2, name: '进行中' },
        { id: 3, name: '已关闭' },
        { id: 4, name: '已完成' },
    ],
    rentBudgetUnit: [
        { id: 1, name: '元/年' },
        { id: 2, name: '元/月' },
        { id: 3, name: '元/平方' },
    ],
    brandName: [
        { id: 1, name: 'Location品牌' },
    ]
};
export var MockCreateList = {
    data: [
        {
            id: 1,
            name: '凯蒂拉克汽车的4s店-北京开3个',
            cityId: 87,
            cityName: '杭州市',
            shopCategory: 1,
            shopCategoryName: '旗舰店',
            shopType: 1,
            shopTypeName: '商场',
            expandNum: 3,
            completedNum: 1,
            statusName: '未发布',
            status: 1,
            assigneeId: null,
            assigneeName: null,
            assigneeMobile: null,
            deadDate: '2022-10-10',
            permissions: [
                { event: '', name: '' },
            ]
        },
        {
            id: 2,
            name: '凯蒂拉克汽车的4s店-北京开3个旗舰店超长超长',
            cityId: 87,
            cityName: '杭州市',
            shopCategory: 1,
            shopCategoryName: '旗舰店',
            shopType: 1,
            shopTypeName: '商场',
            expandNum: 3,
            completedNum: 2,
            statusName: '进行中',
            status: 2,
            assigneeId: null,
            assigneeName: null,
            assigneeMobile: null,
            deadDate: '2022-10-10',
            permissions: [
                { event: '', name: '' },
            ]
        },
        {
            id: 3,
            name: '凯蒂拉克汽车的4s店-北京开3个旗舰店超长超长',
            cityId: 87,
            cityName: '杭州市',
            shopCategory: 1,
            shopCategoryName: '旗舰店',
            shopType: 1,
            shopTypeName: '商场',
            expandNum: 3,
            completedNum: 2,
            statusName: '已关闭',
            status: 3,
            assigneeId: null,
            assigneeName: null,
            assigneeMobile: null,
            deadDate: '2022-10-10',
            permissions: [
                { event: '', name: '' },
            ]
        },
        {
            id: 4,
            name: '凯蒂拉克汽车的4s店-北京开3个旗舰店超长超长',
            cityId: 87,
            cityName: '杭州市',
            shopCategory: 1,
            shopCategoryName: '旗舰店',
            shopType: 1,
            shopTypeName: '商场',
            expandNum: 3,
            completedNum: 2,
            statusName: '已完成',
            status: 4,
            assigneeId: null,
            assigneeName: null,
            assigneeMobile: null,
            deadDate: '2022-10-10',
            permissions: [
                { event: '', name: '' },
            ]
        },
    ]
};
/** 拓店任务模板 */
export var BusinessModel;
(function (BusinessModel) {
    /** Locxx 拓店任务 */
    BusinessModel["Locxx"] = "locxxA";
    /** 加盟商模式A */
    BusinessModel["StandardA"] = "standardA";
    /** 三津汤包 */
    BusinessModel["StandardC"] = "standardC";
    /** 直营模式A */
    BusinessModel["ClusterA"] = "clusterA";
    /** 直营模式B(商圈拓店模板B) */
    BusinessModel["ClusterB"] = "clusterB";
    /** 直营模式C（森马） */
    BusinessModel["ClusterSenma"] = "clusterC";
    /** 加盟+直营A（基诺浦） */
    BusinessModel["StandardAndClusterA"] = "standardAndClusterA";
    /** 加盟+直营B（一鸣） */
    BusinessModel["StandardAndClusterB"] = "standardAndClusterB";
})(BusinessModel || (BusinessModel = {}));
